export default "__VITE_ASSET__JXteu2hU__"